import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';
import { LoginComponent } from './core/authentication/login/login.component';
import { authGuard } from './core/authentication/auth.guard';
import { guestGuard } from './core/authentication/guest.guard';
import { permissionGuard } from './core/authentication/permission.guard';
import { ResetPasswordComponent } from './core/authentication/reset-password/reset-password.component';
import { FirstLoginPasswordComponent } from './core/authentication/first-login-password/first-login-password.component';
import { firstLoginGuard } from './core/authentication/first-login.guard';
import { ForbiddenPageComponent } from './shared/components/forbidden-page/forbidden-page.component';

export const routes: Routes = [
    { path: 'login', component: LoginComponent, canActivate: [guestGuard] },
    { path: 'forgot-password', component: ResetPasswordComponent },
    { path: 'set-password', component: FirstLoginPasswordComponent, canActivate: [firstLoginGuard] },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'users', pathMatch: 'full' },
            { path: 'forbidden', component: ForbiddenPageComponent },
            { path: 'users', canActivate: [permissionGuard('users.view')], loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule) },
            { path: 'channels', canActivate: [permissionGuard('channels.view')], loadChildren: () => import('./features/channels/channels.module').then(m => m.ChannelsModule) },
            { path: 'roles', canActivate: [permissionGuard('roles.view')], loadChildren: () => import('./features/roles/roles.module').then(m => m.RolesModule) },
            {path: 'geographic-nodes', canActivate: [permissionGuard('nodes.view')], loadChildren: () => import('./features/geographic-nodes/geographic-nodes.module').then(m => m.GeographicNodesModule)},
            {path: 'sku-management', canActivate: [permissionGuard('skus.view')], loadChildren: () => import('./features/sku-management/sku-management.module').then(m => m.SkuManagementModule)},
            { path: 'pos', canActivate: [permissionGuard('pos.view')], loadChildren: () => import('./features/pos/pos.module').then(m => m.PosModule) },
            { path: 'surveys', canActivate: [permissionGuard(['surveys.view', 'surveys.create'])], loadChildren: () => import('./features/surveys/surveys.module').then(m => m.SurveysModule) },

        ]
    },
    { path: '**', redirectTo: '' }
];
